/**
 * @file ラベル付きテキスト入力ボックス（Molecule）。AtLabel + AtInput + AtErrorMessage を組み合わせた定義リスト形式のフォーム部品。
 *        react-hook-formのregisterとerrorを受け取り統一的にバリデーションエラーを表示。
 */
import { ChangeEventHandler, HTMLInputTypeAttribute, ReactNode } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import AtLabel from '@/components/atoms/form/AtLabel';
import AtInput from '@/components/atoms/form/AtInput';
import AtErrorMessage from '@/components/atoms/form/AtErrorMessage';

/** 属性定義 */
type Props = Partial<{
  id: string;
  name: string;
  type: HTMLInputTypeAttribute;
  labelClassName: string;
  inputClassName: string;
  dtClassName: string;
  ddClassName: string;
  defaultValue: string;
  value: string | number | readonly string[];
  autoComplete: string;
  placeholder: string;
  disabled: boolean;
  maxLength: number;
  minLength: number;
  required: boolean;
  register: UseFormRegisterReturn;
  onChange: ChangeEventHandler<HTMLInputElement>;
  error: FieldError;
  testid: string;
  children: ReactNode;
}>;

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const MlLabeledTextBox = ({
  children,
  type,
  id,
  name,
  labelClassName,
  inputClassName,
  dtClassName,
  ddClassName,
  defaultValue,
  value,
  autoComplete,
  placeholder,
  disabled,
  maxLength,
  minLength,
  required,
  onChange,
  register,
  error,
  testid,
}: Props) => {
  return (
    <>
      <dt className={dtClassName}>
        <AtLabel className={labelClassName} htmlFor={id}>
          {children}
        </AtLabel>
      </dt>
      <dd className={ddClassName}>
        <AtInput
          type={type}
          id={id}
          name={name}
          defaultValue={defaultValue}
          value={value}
          className={inputClassName}
          autoComplete={autoComplete}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          minLength={minLength}
          required={required}
          register={register}
          onChange={onChange}
          error={error}
          testid={testid}
        />
        <AtErrorMessage error={error} />
      </dd>
    </>
  );
};
export default MlLabeledTextBox;
